
const PREFERENCES_LOCAL_STATE = {
    initialState: true,

    emailAddress: null,
    emailMe: null,
    mailingAddress: {
        streetAddress1: null,
        streetAddress2: null,
        city: null,
        countyCode: null,
        state: null,
        postalCode: null
    },
    mailingAddressUpdateAllowed: null,
    paperless1095: null,
    paperlessNotices: null,
    phoneNumber: null,
    preferredSpokenLanguage: 'English',
    preferredWrittenLanguage: 'English',
    textMe: null
};


export const INITIALS = {
    PREFERENCES_LOCAL_STATE
};